import {
  ADMIN_DASHBOARD_ACCOUNT_FILTERS,
  ADMIN_DASHBOARD_COMPARE_PERIOD,
  ADMIN_DASHBOARD_COMPARE_SHORTCUT,
  ADMIN_DASHBOARD_PERIOD,
  ADMIN_EVENTS_PERIOD,
  ACTIVATION_FUNNEL_PERIOD,
  CHURN_SIGNALS_PERIOD,
  LINK_CLICK_ANALYTICS_PERIOD,
  FEATURE_USAGE_PERIOD,
  LINK_CLICK_ANALYTICS_SELECTED_LINK,
  QUESTIONNAIRE_ANALYTICS_PERIOD,
} from '../../../../constants'
import { LoadingStatusEnum } from '../../../../store/types'
import { SortDirectionCapital } from '../../../../types'
import { AccountFiltersEnum, AccountType } from '../../Accounts/api/types'
import {
  AdminBrokerServer,
  BrokerServerColumnKey,
  BrokerServerPagination,
  AdminDashboardMetricsByCountryDTO,
  AdminDashboardMetricsDTO,
  AdminRegistrationPlatformMetricsDTO,
  TradingLogStats,
  PlatformRequestStats,
  QuestionnaireStats,
  TrackedLinkClickCountryStatsItem,
  TrackedLinkClickStats,
  UsersAccountsChartPoint,
  AccountsValueChartPoint,
  CountryDetailsChartData,
  AdminBreachEventItem,
} from '../api/types'

const savedPeriod = JSON.parse(localStorage.getItem(ADMIN_DASHBOARD_PERIOD) || 'null')
const savedComparePeriod = JSON.parse(
  localStorage.getItem(ADMIN_DASHBOARD_COMPARE_PERIOD) || 'null',
)

const savedCompareShortcut = JSON.parse(
  localStorage.getItem(ADMIN_DASHBOARD_COMPARE_SHORTCUT) || 'null',
)

const questionnaireStatsSavedPeriod = JSON.parse(
  localStorage.getItem(QUESTIONNAIRE_ANALYTICS_PERIOD) || 'null',
)
const linkClickAnalyticsSavedPeriod = JSON.parse(
  localStorage.getItem(LINK_CLICK_ANALYTICS_PERIOD) || 'null',
)
const activationFunnelSavedPeriod = JSON.parse(
  localStorage.getItem(ACTIVATION_FUNNEL_PERIOD) || 'null',
)
const featureUsageSavedPeriod = JSON.parse(localStorage.getItem(FEATURE_USAGE_PERIOD) || 'null')
const adminEventsSavedPeriod = JSON.parse(localStorage.getItem(ADMIN_EVENTS_PERIOD) || 'null')
const churnSignalsSavedPeriod = JSON.parse(localStorage.getItem(CHURN_SIGNALS_PERIOD) || 'null')
const linkClickAnalyticsSelectedLink = JSON.parse(
  localStorage.getItem(LINK_CLICK_ANALYTICS_SELECTED_LINK) || '"all"',
)

const savedAccountFilters = JSON.parse(
  localStorage.getItem(ADMIN_DASHBOARD_ACCOUNT_FILTERS) || 'null',
)

export type AdminDashboardCompareShortcut = 'period' | 'week' | 'month' | 'year' | 'custom' | null

export const topAccountsInitialFilters: AccountFiltersEnum[] = []

export const createEmptyCountryDetailsData = (): CountryDetailsChartData => ({
  usersAccountsChart: [] as UsersAccountsChartPoint[],
  accountsValueChart: [] as AccountsValueChartPoint[],
})

const brokerServersColumns: BrokerServerColumnKey[] = [
  'name',
  'type',
  'tags',
  'accountsCount',
  'accountsTotalValue',
]

const brokerServersInitialPagination: BrokerServerPagination = {
  perPage: 20,
  page: 1,
  columns: brokerServersColumns,
  itemCount: 0,
  pageCount: 0,
  hasPreviousPage: false,
  hasNextPage: false,
  period: [null, null],
  account: 0,
  order: SortDirectionCapital.desc,
  orderBy: 'accountsCount',
  fromCalendar: false,
  search: '',
  filters: savedAccountFilters ?? [],
}

const initialState = {
  metrics: {
    data: {} as AdminDashboardMetricsDTO,
    loading: LoadingStatusEnum.Idle,
  },
  breachEvents: {
    data: [] as AdminBreachEventItem[],
    loading: LoadingStatusEnum.Idle,
  },
  registrationPlatformMetrics: {
    data: { platforms: [] } as AdminRegistrationPlatformMetricsDTO,
    loading: LoadingStatusEnum.Idle,
  },
  metricsByCountry: {
    data: [] as AdminDashboardMetricsByCountryDTO,
    loading: LoadingStatusEnum.Idle,
  },
  countryDetails: {
    data: createEmptyCountryDetailsData(),
    country: null as string | null,
    isOpen: false,
    loading: LoadingStatusEnum.Idle,
  },
  topAccounts: {
    data: [] as AccountType[],
    loading: LoadingStatusEnum.Idle,
    filters: topAccountsInitialFilters,
  },
  brokerServers: {
    data: [] as AdminBrokerServer[],
    loading: LoadingStatusEnum.Idle,
    pagination: brokerServersInitialPagination,
  },
  tradingLogStats: {
    data: [] as TradingLogStats[],
    loading: LoadingStatusEnum.Idle,
  },
  questionnaireStats: {
    data: {} as QuestionnaireStats,
    loading: LoadingStatusEnum.Idle,
  },
  platformRequestStats: {
    data: {} as PlatformRequestStats,
    loading: LoadingStatusEnum.Idle,
  },
  trackedLinkClickStats: {
    data: {} as TrackedLinkClickStats,
    loading: LoadingStatusEnum.Idle,
  },
  trackedLinkClickCountryStats: {
    data: [] as TrackedLinkClickCountryStatsItem[],
    loading: LoadingStatusEnum.Idle,
  },
  questionnaireStatsPeriod: questionnaireStatsSavedPeriod ?? [null, null],
  linkClickStatsPeriod: linkClickAnalyticsSavedPeriod ?? [null, null],
  activationFunnelPeriod: activationFunnelSavedPeriod ?? [null, null],
  featureUsagePeriod: featureUsageSavedPeriod ?? [null, null],
  adminEventsPeriod: adminEventsSavedPeriod ?? [null, null],
  churnSignalsPeriod: churnSignalsSavedPeriod ?? [null, null],
  linkClickSelectedKey: linkClickAnalyticsSelectedLink ?? 'all',
  period: savedPeriod ?? [null, null],
  comparePeriod: savedComparePeriod ?? [null, null],
  compareShortcut: (savedCompareShortcut as AdminDashboardCompareShortcut) ?? null,
  accountFilters: savedAccountFilters ?? [],
  loading: LoadingStatusEnum.Idle,
}

export type StateType = typeof initialState

export default initialState
